module.exports = __webpack_public_path__ + "img/info-2.02a9ca1e.jpg";